/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Provision_PreviewInputs */

const cs_deal_provision_preview = /** @type {(inputs: Deal_Provision_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Očekávaná provize kanceláře`)
};

const en_deal_provision_preview = /** @type {(inputs: Deal_Provision_PreviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expected agency take`)
};

/**
* | output |
* | --- |
* | "Expected agency take" |
*
* @param {Deal_Provision_PreviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_provision_preview = /** @type {((inputs?: Deal_Provision_PreviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Provision_PreviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_provision_preview(inputs)
	return cs_deal_provision_preview(inputs)
});